module.exports = __webpack_public_path__ + "static/media/calendar.ade1f9d4.svg";